module.exports = __webpack_public_path__ + "static/media/i-logo-orange.0cc00217.png";